import { createGlobalStyle } from "styled-components";

import ProximaNova from "../assets/fonts/proximanova.ttf";
import theme from "./theme";

export default createGlobalStyle`
    @font-face {
        font-family: 'ProximaNova';
        src: local('ProximaNova'), local('ProximaNova'),
        url(${ProximaNova});
        font-weight: 300;
        font-style: normal;
    }

    body, select, input {
      font-family: "ProximaNova";
      color: ${theme.colors.black};
      font-size: ${theme.fonts.medium.fontSize};
      line-height: ${theme.fonts.medium.lineHeight};
    }

    * {
      box-sizing: border-box;
    }

`;
